export class NameModel {
  First: string;
  FirstAndLast: string;
  Last: string;

}
